<template>
    <div class="editable-date">
        <div class="text" :id="id">{{ value || '&nbsp;' }}</div>
        <div ref="template" class="template">
            <flat-pickr class="form-control" ref="input"  :config="config"  v-model="valueMutable" @input="storeValue"/>
        </div>
    </div>
</template>

<script>
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default {
    props: {
        id: {
            type: String,
            default() {
                return `tooltip-${this._uid}`;
            },
        },
        value: String,
    },
    data() {
        return {
            valueMutable: (this.value == null || this.value == "0000-00-00" || this.value == "") ? new Date() : this.value,
            config: {
                defaultDate: new Date(),
                dateFormat: 'Y-m-d',
            },
        }
    },
    mounted() {
        this.tooltip = tippy(`#${this.id}`, {
            allowHTML: true,
            content: this.$refs.template,
            trigger: 'click',
            interactive: true,
            placement: 'bottom',
            onShown: function () {
                this.$refs.input.fp.open();
            }.bind(this)
        });
    },
    methods: {
        storeValue() {
            this.$emit('input', this.valueMutable);
            this.closeTooltip();
        },
        closeTooltip() {
            this.tooltip[0].hide();
        },
        reset() {
            this.valueMutable = this.value;
            this.closeTooltip();
        }
    }
}
</script>

<style scoped>
.editable-date .text {
    border-bottom: 1px dashed #aaa;
    cursor: pointer;
}

.editable-date .template {
    color: #333;
}
</style>
